class UpdateReferralCodeStatusReq {
  constructor() {
    this.referralCodeId = null;
    this.newStatus = null;
  }
}

// module.exports = UpdateReferralCodeStatusReq;
export default UpdateReferralCodeStatusReq;
